/**
 * Navigation guard checking for sesssion
 */
// import {getCollections} from '@/helpers/localbase'
/* Helpers */
import Helper from '@/helpers/helpers'




 export default async function navguard ({to, next, store, from}) {
  
    // console.log(to, from, next, store, process.env)

    /**
     * Update route from store state
     */
    store.commit('updateRouteFrom', from)


    /**
     * Get user data from indexed db 
     */
    // const [user] = await getCollections({name : 'user'})
    let user = Helper.getCookie('stakeUserType') ?? 'subscriber';

   

    /**
     * Check if public page 
     * then bypass auth checker
     */
    console.log(user, 'Navguard to', to)
    if(to.meta.group.includes('public')) {
        next()

        return;
    }


    // check if has session if none redirect to login
    if(to.name != 'login') {
        if(!Helper.getCookie('springstoken')) {
            next({name : 'login'})

            return;
        } 
        if(to.name == 'dashboard' && user == 'administrator') next({name : 'adminDashboard'});
        if(to.name == 'administrator' && user == 'subscriber') next({name : 'dashboard'});
    } else if(to.name == 'login') {
        if(!Helper.getCookie('springstoken')) {
            next()
        } else {
            if(user == 'subscriber') next({name : 'dashboard'});
            if(user == 'administrator') next({name : 'adminDashboard'});
        }
    }
    

    next();
 }